import { ScrollToTop, setOriginationStorage } from '@applyonline/shared'

import { useEffect, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { BrowserRouter as Router } from 'react-router-dom'
import { AppContext, useAppStoreProvider } from '../../data/AppContext'
import TopLevelRoutes from './Routes'
import Header from './components/Header'

const App = (): JSX.Element => {
  const { i18n } = useTranslation()

  const appStore = useAppStoreProvider()

  useEffect(() => {
    setOriginationStorage(appStore.originationFromUrl)
  }, [appStore.originationFromUrl])

  return (
    <AppContext.Provider value={appStore}>
      <Router>
        <ScrollToTop />
        <Header language={i18n.language} />
        <TopLevelRoutes />
      </Router>
    </AppContext.Provider>
  )
}

export default App
